export default __webpack_public_path__ + "static/media/facebook.741b61a0.svg";